<template>
  <main class="sustainability-page">
    <aside class="sustainability-page__review-notice">
      We’re currently reviewing the environmental claims and sustainability
      information on this page against the latest guidance and making updates
      where necessary.
    </aside>
    <HeadlessLayout :sections="content" />
  </main>
</template>

<script>
import SustainabilityMainContent from "@/content/SustainabilityMain.json";
import HeadlessLayout from "@/layouts/HeadlessLayout.vue";

export default {
  name: "Sus",
  components: {
    HeadlessLayout,
  },
  data() {
    return {
      content: SustainabilityMainContent,
    };
  },
};
</script>

<style lang="scss" scoped>
.sustainability-page {
  position: relative;

  &__review-notice {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 8;
    padding: 14px 20px;
    background: rgba($color-white, 0.95);
    color: $color-black;
    text-align: center;
    @include editorial-body(14px);
    line-height: 1.5;
  }
}
</style>
